import { TLeagueoflegends } from '../locales/en/leagueoflegends';

export function getLeagueGamemode(map: string): TLeagueoflegends | null {
  return (map === 'howlingabyss' || map === 'summonersrift') ? 'gamemodes.battlearena' : null;
}
